// extracted by mini-css-extract-plugin
export default {"outdated":"Outdated-outdated-fR4","outdatedModal":"Outdated-outdatedModal-DIK","outdatedTitle":"Outdated-outdatedTitle-ZIn","outdatedText":"Outdated-outdatedText-cCo"};